<template>
  <div class="c-users-information">
    <header class="header">
      <div class="c-heading">
        <p4a-icon class="header__icon" :icon="'user'" />
        <p class="header__text">{{ $t('usersInformation.headerTitle') }}</p>
      </div>
      <p4a-button
        class="header__close-button"
        @click="closeWindow"
        :showIcon="true"
        :onlyIconVisible="true"
        :icon="'close'"
        :product="'ds'"
        :size="'medium'"
        :disable="false"
        :text="''">
      </p4a-button>
    </header>
    <form @submit.prevent="onSubmit">
      <tabs :title="$t('usersInformation.tabs.title')" v-if="data && mfaDetails">
        <tab :name="$t('usersInformation.tabs.general')" :selected="true" :icon="'properties'" :warningColor="tabDataIsMissed === 'general'">
          <general
          v-on:reEnterPassword="onReEnterPassword"
            :username.sync="data.Username"
            :name.sync="data.Name"
            :email.sync="data.Email"
            :toInform.sync="data.ToInform"
            :description.sync="data.Description"
            :emailIsInvalid="emailIsInvalid"
            :EmailIsReadOnly="data.EmailIsReadOnly"
            :NameIsReadOnly="data.NameIsReadOnly"
            :UsernameIsReadOnly="data.UsernameIsReadOnly"
            :password="Password"
          >
          </general>
        </tab>
        <tab :name="$t('usersInformation.tabs.personalInformation')" :icon="'user'" :warningColor="tabDataIsMissed === 'personal'">
          <personal
            :firstName.sync="data.FirstName"
            :lastname.sync="data.Lastname"
            :personalEmail.sync="data.PersonalEmail"
            :workPhone.sync="data.WorkPhone"
            :receiveNewsletter.sync="data.ReceiveNewsletter"
          ></personal>
        </tab>
        <tab :name="$t('usersInformation.tabs.companyInformation')" :icon="'company'" :warningColor="tabDataIsMissed === 'company'">
          <company
            :companyName.sync="data.CompanyName"
            :companyPosition.sync="data.CompanyPosition"
          ></company>
        </tab>
        <tab :name="$t('usersInformation.tabs.signature')" :icon="'autograph'" :warningColor="tabDataIsMissed === 'autograph'">
          <signature
            :signature.sync="data.Signature"
            :signatureQuillDelta.sync="data.SignatureQuillDelta"
            :IsAutoGenerateSignature="data.IsAutoGenerateSignature"
          ></signature>
        </tab>
        <tab v-if="disableVerify()" :name="$t('usersInformation.tabs.verify')" :icon="'locked'" :warningColor="tabDataIsMissed === 'verify'">
          <verify
            :mfaDetails="mfaDetails"
          ></verify>
        </tab>
         <tab v-if="enableAddStampForUser()" :name="$t('usersInformation.tabs.stamp')" :icon="'stamp'" :warningColor="tabDataIsMissed === 'stamp'">
          <stamp
          :privilegizedEntityId="privilegizedEntityId"
          @userStamp="saveStamp"
          ></stamp>
        </tab>
      </tabs>
      <!-- buttons -->
      <div class="buttons-row buttons-row__hastabs">
        <p4a-button
          @click="closeWindow"
          :onlyIconVisible="false"
          :size="'large'"
          :product="'ts'"
          :disable="false"
          :text="$t('usersInformation.buttons.close')">
        </p4a-button>
        <p4a-button
          @click="onSubmit"
          class="closeButton"
          :onlyIconVisible="false"
          :product="'ds'"
          :size="'large'"
          value="Submit"
          :disable="false"
          :text="$t('usersInformation.buttons.save')">
        </p4a-button>
      </div>
      <!-- toest -->
      <p4a-toast :maxWidth="370" :stackSize="2" />
    </form>
  </div>
</template>

<script>
import tabs from '../../tabs/tabs'
import tab from '../../tabs/tab'
import general from './usersInformation/General'
import personal from './usersInformation/personal'
import company from './usersInformation/company'
import signature from './usersInformation/signature'
import verify from './usersInformation/verify'
import stamp from './usersInformation/Stamp'

import * as usersInformationApi from 'api/usersInformationApi'
import * as usersAndGroupsApi from 'api/usersAndGroupsApi'
import * as settingsApi from 'api/settingsApi'
import * as stampApi from 'api/stampApi.js'
import _ from 'lodash'

export default {
  components: {tabs, tab, general, personal, company, signature, verify, stamp},
  data () {
    return {
      data: null,
      tabDataIsMissed: '',
      emailIsInvalid: false,
      mfaDetails: null,
      stampSettings: null,
      privilegizedEntityId: '',
      stampObject: [],
      Password: null
    }
  },
  created () {
    usersInformationApi.getUsersInformation().then(data => {
      this.data = data
      this.privilegizedEntityId = data.PrivilegizedEntityId
      this.Password = ''
      usersInformationApi.getMfa().then(data => {
        data.MfaSecret = data.MfaSecret.replace(/(\w{4})/g, '$1 ').replace(/(^\s+|\s+$)/, '')
        this.mfaDetails = data
      })
    })
    this.getStampSettings()
  },
  computed: {
    revalidatePassword () {
      return this.$store.getters.getRevalidatePassword
    }
  },
  methods: {
    closeWindow () {
      window.close()
    },
    onReEnterPassword (value) {
      this.Password = value
    },
    disableVerify () {
      return (this.mfaDetails.SystemConfigMfaEnabled && !this.mfaDetails.SystemConfigMfaForced)
    },
    getStampSettings () {
      settingsApi.getStampSettings().then(result => {
        if (result) {
          this.stampSettings = result
        }
      }).catch(exception => {
      })
    },
    enableAddStampForUser () {
      if (this.stampSettings != null) {
        return this.stampSettings.EnableAddStampForUser
      } else {
        return false
      }
    },
    saveStamp ({ isNewStamp, stamp, stampIndex }) {
      if (isNewStamp) {
        this.stampObject.push({stampIndex: stampIndex, hasStamp: isNewStamp, userStamp: stamp})
      }
    },
    async Submit (data) {
      let check = ['Username', 'Name', 'Email']
      const vm = this
      data = _.pick(data, check)
      // Checking for required fields
      for (let key in data) {
        if (data[key] === '') {
          // To show the warning on the right tab title you need to specify keys
          // For example: now it will warn you that some data is missed in general
          if (key === 'Username' || key === 'name' || key === 'Email') {
            this.tabDataIsMissed = 'general'
            setTimeout(function () {
              vm.tabDataIsMissed = ''
            }, 4000)
          }
          return this.$p4aToast.show(this.$i18n.t('general.errorHeader'), this.$i18n.t('general.errorEmptyFields'), 'error', 4000)
        }
      }
      // Checking for invalid Email
      let emailIsValid = await this.$store.dispatch('emailIsValid', data['Email'])
      if (!emailIsValid && data['Email'] !== '') {
        this.emailIsInvalid = true
        this.tabDataIsMissed = 'general'
        setTimeout(function () {
          vm.tabDataIsMissed = ''
          vm.emailIsInvalid = false
        }, 4000)
        return this.$p4aToast.show(this.$i18n.t('general.errorHeader'), this.$i18n.t('general.errorInvalidEmail'), 'error', 4000)
      }
      // saving the data if there are no errors and then show the success message
      let self = this
      usersInformationApi.saveUsersInformation(self.data).then(result => {
        let selectedStamp = self.stampObject
        let stampUploadProcess = []
        for (let prop in selectedStamp) {
          if (selectedStamp[prop].hasStamp) {
            var stampUploadPromise = stampApi.uploadStampForUser(selectedStamp[prop].userStamp, selectedStamp[prop].userStamp.name, self.privilegizedEntityId, selectedStamp[prop].stampIndex)
            stampUploadProcess.push(stampUploadPromise)
          }
        }
        Promise.all(stampUploadProcess).then(
          result => {
            self.closeWindow()
          }).catch(exception => {
          this.$p4aToast.show(this.$i18n.t('general.errorHeader'), this.$i18n.t('general.errorStampUpload'), 'error', 4000)
        })
      })
    },
    async onSubmit () {
      let data = Object.assign(this.data)
      if (this.revalidatePassword) {
        usersAndGroupsApi.revalidateCredentials({ username: this.data.Username, password: this.Password }).then(auth => {
          if (auth.LoginValidated === true) {
            this.Submit(data)
          } else {
            this.$store.commit('setShowPasswordMatchWarning', true)
          }
        })
      } else {
        this.Submit(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/UsersInformation.vue